import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getProductionBatchByProductionOrderId, productionOrdersSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useRoute } from '@react-navigation/native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { getNCFilesByProductionOrderId } from '@reducers/manufacture';
import { loadSingleBatch } from '@reducers/batch';
import { SingleBatchOrBatchList } from '@v2/pages/common/components/SingleBatchOrBatchList/SingleBatchOrBatchList';
import { useProductionOrderDetails } from '@v2/pages/common/hooks/useProductionOrderDetails';
import { ProductionOrderScreenProps } from '@v2/pages/productionOrder/common/interfaces';
import { parseRouteParamAsNumber } from '@helpers';

interface ProductionOrderDetailsBatchProps extends ProductionOrderScreenProps {}

const ProductionOrderDetailsBatchComponent: FC<ProductionOrderDetailsBatchProps> = ({
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  productionOrdersSearch,
  loadSingleBatch,
}) => {
  const title = useTitle();
  const route = useRoute();

  const productionOrderId = parseRouteParamAsNumber(route.params?.productionOrderId);

  useProductionOrderDetails({
    productionOrdersSearch,
    updateHeaderConfig,
    getNCFilesByProductionOrderId,
    getProductionBatchByProductionOrderId,
    loadSingleBatch,
  });

  return (
    <DetailsPageWrapper title={title.batch}>
      <SingleBatchOrBatchList fetchBatchList={getProductionBatchByProductionOrderId} idForGettingBatchList={productionOrderId} />
    </DetailsPageWrapper>
  );
};

const ProductionOrderDetailsBatch = connect(null, {
  productionOrdersSearch,
  updateHeaderConfig,
  getNCFilesByProductionOrderId,
  getProductionBatchByProductionOrderId,
  loadSingleBatch,
})(ProductionOrderDetailsBatchComponent);

export { ProductionOrderDetailsBatch };
